import React from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import './Reviews.css';
import Review from '../Review/Review';
import { Modal, Card, Form, Spinner } from 'react-bootstrap';
import useAuth from '../../hooks/useAuth';
import profile from '../../media/profile.png';
import Rating from 'react-rating';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';



function ShareFeedbackModal(props) {
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const [value, setValue] = useState(0);
    const [name, setName] = useState("");
    const [canSubmit, setCanSubmit] = useState(false);
    const [reviewSending, setReviewSending] = useState(false);

    const checkReview = (e) => {
        const review = e.target.value;
        const result = /[^\s\\]/.test(review);
        if (result) {
            setCanSubmit(true);
        }
        else {
            setCanSubmit(false);
        }
    }


    const onSubmit = data => {
        setReviewSending(true);
        if (name.length > 0) {
            data.name = name;
        }
        else {
            data.name = "Anonymous";
        }
        data.photoURL = props?.user?.photoURL;
        data.rating = value;
        fetch('https://gentle-tor-99938.herokuapp.com/reviews', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(result => {
                if (result.insertedId) {
                    props.onHide();
                    swal("Thank you for your feedback", "We have added your feedback. Refresh the website to see your feedback on the landing page.", "success");
                    reset();
                }
                else {
                    swal("Something Went Wrong!", "We couldn't save your review. Please try again later", "error");
                }
            })
            .finally(() => setReviewSending(false));

    }
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="feedback"
        >
            <Modal.Header closeButton className="p-3">
                <Modal.Title id="contained-modal-title-vcenter">
                    Share your feedback
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Modal.Body className="p-4">
                    <div className="form-floating mb-2 ms-2">
                        <input
                            name="name"
                            {...register("name")}
                            onBlur={(e) => {
                                setName(e.target.value);
                            }}
                            type="text" className="form-control" id="reviewerName" placeholder="Your Name" />
                        <label htmlFor="reviewerName">Your Name</label>
                    </div>
                    <Card.Title className="m-0 ms-2">
                        <Rating
                            className="m-0"
                            emptySymbol="far fa-star icon-color"
                            fullSymbol="fas fa-star icon-color"
                            fractions={2}
                            value={value}
                            onChange={(value) => {
                                setValue(value);
                            }}
                        ></Rating>
                    </Card.Title>
                    <Form.Group className="mt-2 mb-3" controlId="exampleForm.ControlTextarea1">
                        <Form.Control as="textarea" rows={3} placeholder="What's your thought about us?" required {...register("review")} onChange={checkReview} />
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    {
                        reviewSending
                            ?
                            <button type="submit" className="btn btn-success w-100 disabled d-flex align-items-center justify-content-center">
                                <span className="m-0">Loading</span>
                                <Spinner className="m-0 ms-2" animation="border" size="sm" />
                            </button>
                            :
                            <button type="submit" className={
                                canSubmit
                                    ?
                                    "btn btn-success w-100"
                                    :
                                    "btn btn-secondary w-100 disabled btn-not"
                            }>
                                Post
                            </button>
                    }
                </Modal.Footer>
            </Form>
        </Modal >
    );
}



const Reviews = ({ reviews }) => {
    const slideCount = 2

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: slideCount,
        slidesToScroll: slideCount,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 3000,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: slideCount,
                    slidesToScroll: slideCount,
                    infinite: true,
                    dots: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const [modalShow, setModalShow] = React.useState(false);
    const { user } = useAuth();

    const navigate = useNavigate();


    return (
        <div className="my-5 pb-5">
            <div className="mb-5">
                <h1 className="headline fw-bold mb-2">Customer <span className="text-warning">Feedbacks</span></h1>
                <button onClick={() => {
                    setModalShow(true)
                    // if (user?.email) {

                    // }
                    // else {
                    //     swal("Please Login", "Please login first to share your feedback kindly", "warning");
                    //     navigate('/login');
                    // }
                }} className="btn btn-lg btn-outline-success">Share your feedback</button>

                <ShareFeedbackModal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    user={user}
                />
            </div>



            <Slider {...settings} className={slideCount === 1 ? "col-12 col-lg-9 mx-auto mt-lg-4 mb-5" : "col-12 mx-auto mt-lg-4 mb-5"}>
                {
                    reviews.map((review, index) => <Review
                        key={index}
                        review={review}
                    >
                    </Review>)
                }
            </Slider>

        </div >

    );
};

export default Reviews;